// Mesure d'usage (PostHog EU) : suivi complet pour TOUS les visiteurs, sans bandeau
// ni case (choix assumé de Rejouis, 2026-10-16) — clics, heatmaps, replay de session,
// y compris pour ceux qui ne vont pas au bout. Désactivable en pied de page.
// Garde-fous : saisies et photos clients masquées, identify par ID Shopify seul.
// Le journal local (screen_viewed, recherche, scan…) part avec la demande →
// bloc « Parcours » de la fiche demande au lab.
// Les événements passent par /ingest (proxy Netlify → eu.i.posthog.com).
import posthog from 'posthog-js';
import { MODE_APERCU } from './flags.js';

// Clé de projet PUBLIQUE (envoyée au navigateur de toute façon), pas un secret.
const posthogKey = import.meta.env.VITE_POSTHOG_KEY || 'phc_ydKudQUnsHXXK7hiDvJYmRTF8Ut9nwybQPkFEr6zKokV';
const CONSENT_KEY = 'reprise_mesure'; // 'refus' = aucune mesure (lien du pied de page)
const JOURNAL_KEY = 'reprise_journal';
const JOURNAL_MAX = 150;

export const mesureConfiguree = Boolean(posthogKey && posthogKey !== 'phc_your_project_token');

function lire(cle, store = localStorage) {
  try { return store.getItem(cle); } catch { return null; }
}
function ecrire(cle, valeur, store = localStorage) {
  try { if (valeur == null) store.removeItem(cle); else store.setItem(cle, valeur); } catch { /* navigation privée */ }
}

export function mesureRefusee() { return MODE_APERCU || lire(CONSENT_KEY) === 'refus'; }

if (mesureConfiguree && !mesureRefusee()) {
  posthog.init(posthogKey, {
    api_host: '/ingest',
    ui_host: 'https://eu.posthog.com',
    person_profiles: 'identified_only',
    enable_heatmaps: true, // clics + défilement, séparés par écran via le #hash de l'URL
    capture_exceptions: {
      capture_unhandled_errors: true,
      capture_unhandled_rejections: true,
      capture_console_errors: false,
    },
    session_recording: {
      maskAllInputs: true,
      // Texte sensible (e-mail du compte…) : classe ph-mask.
      maskTextSelector: '.ph-mask',
      // Photos envoyées par les clients (aperçus locaux, photos de lot) et QR
      // Mondial Relay : jamais dans les enregistrements.
      blockSelector: 'img[src^="data:"], img[src^="blob:"], img[src*="/api/qr"], .ph-no-capture',
    },
  });
  // Visiteurs passés par l'ancienne version (mode anonyme = opt-out) : on réactive.
  if (posthog.has_opted_out_capturing()) posthog.opt_in_capturing();
}

function appareil() {
  const ua = navigator.userAgent || '';
  if (/iPad|Tablet/i.test(ua) || (/Android/i.test(ua) && !/Mobi/i.test(ua))) return 'Tablette';
  if (/Mobi|iPhone|Android/i.test(ua)) return 'Smartphone';
  return 'Ordinateur';
}

// Événement nommé : envoyé à PostHog + noté dans le journal local.
const CHAMPS_JOURNAL = {
  screen: 'screen', query: 'query', match_count: 'nbMatch', declared_condition: 'etat',
  estimated_credit: 'credit', item_count: 'nbJouets', result_count: 'nbResultats',
};
export function suivre(event, props = {}) {
  if (mesureRefusee()) return;
  if (posthog.__loaded) posthog.capture(event, props);
  const etape = { t: new Date().toISOString(), event };
  for (const [k, v] of Object.entries(props)) if (CHAMPS_JOURNAL[k] && v != null) etape[CHAMPS_JOURNAL[k]] = v;
  let journal = [];
  try { journal = JSON.parse(lire(JOURNAL_KEY, sessionStorage) || '[]'); } catch { /* journal corrompu */ }
  // Première étape de la visite : l'appareil (PostHog le note aussi : $device_type).
  if (!journal.length) journal.push({ t: etape.t, event: 'session_start', appareil: appareil() });
  journal.push(etape);
  ecrire(JOURNAL_KEY, JSON.stringify(journal.slice(-JOURNAL_MAX)), sessionStorage);
}

// Pied de page : couper / réactiver toute mesure (droit d'opposition). Recharge la page.
export function basculerMesure() {
  ecrire(CONSENT_KEY, mesureRefusee() ? null : 'refus');
  if (mesureRefusee()) ecrire(JOURNAL_KEY, null, sessionStorage);
  window.location.reload();
}

// Joint à la demande (sauf mesure désactivée) : IDs PostHog + journal.
export function parcoursPosthog() {
  if (mesureRefusee()) return null;
  let etapes = [];
  try { etapes = JSON.parse(lire(JOURNAL_KEY, sessionStorage) || '[]'); } catch { /* vide */ }
  const id = posthog.__loaded ? posthog.get_distinct_id() : '';
  const session = posthog.__loaded ? posthog.get_session_id() : '';
  return { id: id || '', session: session || '', etapes };
}

export function oublierJournal() { ecrire(JOURNAL_KEY, null, sessionStorage); }

export default posthog;
